module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['fo-btn', {
      otherFoBtn: true
    }],
    attrs: {
      "id": "common-page-footer"
    }
  }, [_c('footer', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "linksBox"
  }, [_c('div', {
    staticClass: "links"
  }, [_c('dl', [_c('dt', [_vm._v("在线预定")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "tag": "a",
      "rel": "nofollow",
      "href": _vm.WWW_URL + 'newzhaowo/appoint?q=1',
      "target": "_blank"
    }
  }, [_vm._v("定制流程")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "tag": "a",
      "rel": "nofollow",
      "href": _vm.WWW_URL + 'newzhaowo/pay?q=1',
      "target": "_blank"
    }
  }, [_vm._v("支付方式")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("消费保障")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "tag": "a",
      "rel": "nofollow",
      "href": _vm.WWW_URL + 'newzhaowo/service?q=1',
      "target": "_blank"
    }
  }, [_vm._v("实名认证")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "tag": "a",
      "rel": "nofollow",
      "href": _vm.WWW_URL + 'newzhaowo/service?q=2',
      "target": "_blank"
    }
  }, [_vm._v("定金担保")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "tag": "a",
      "rel": "nofollow",
      "href": _vm.WWW_URL + 'newzhaowo/service?q=3',
      "target": "_blank"
    }
  }, [_vm._v("价格透明")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("售后服务")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "tag": "a",
      "rel": "nofollow",
      "href": _vm.WWW_URL + 'newzhaowo/aftersale?q=1',
      "target": "_blank"
    }
  }, [_vm._v("无忧退款")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "tag": "a",
      "rel": "nofollow",
      "href": _vm.WWW_URL + 'newzhaowo/aftersale?q=2',
      "target": "_blank"
    }
  }, [_vm._v("应急服务")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "tag": "a",
      "rel": "nofollow",
      "href": _vm.WWW_URL + 'newzhaowo/aftersale?q=3',
      "target": "_blank"
    }
  }, [_vm._v("免费咨询")])])])]), _vm._v(" "), _c('div', {
    staticClass: "erweima"
  }, [(1 === 0) ? _c('dl', [_c('dt', [_vm._v("加入备婚群")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (1 === 0 && _vm.showDown) ? _c('span', {
    staticClass: "line"
  }) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), (_vm.showType) ? _c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "flex-row",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.linkList.caseLinkList), function(key) {
    return [_c('a', {
      staticClass: "tag-name",
      attrs: {
        "href": _vm.curlurl2P + key.link
      }
    }, [_vm._v(_vm._s(key.name))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "flex-row",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.linkList.workLinkList), function(key) {
    return [_c('a', {
      staticClass: "tag-name",
      attrs: {
        "href": _vm.curlurl2P + key.link
      }
    }, [_vm._v(_vm._s(key.name))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "flex-row",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.linkList.hotelLinkList), function(key) {
    return [_c('a', {
      staticClass: "tag-name",
      attrs: {
        "href": _vm.curlurl2P + key.link
      }
    }, [_vm._v(_vm._s(key.name))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "flex-row",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.linkList.hqLinkList), function(key) {
    return [_c('a', {
      staticClass: "tag-name",
      attrs: {
        "href": _vm.curlurl2P + key.link
      }
    }, [_vm._v(_vm._s(key.name))])]
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "copeRight"
  }, [_c('div', {
    staticClass: "about fl"
  }, [_c('p', {
    staticClass: "aboutUs"
  }, [_c('a', {
    attrs: {
      "tag": "a",
      "target": "_blank",
      "rel": "nofollow",
      "href": _vm.curlurl2P + '/newzhaowo/contact'
    }
  }, [_vm._v("联系找我")]), _vm._v(" "), _c('a', {
    attrs: {
      "tag": "a",
      "target": "_blank",
      "rel": "nofollow",
      "href": _vm.curlurl2P + '/newzhaowo/falv'
    }
  }, [_vm._v("法律声明")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "nofollow",
      "href": _vm.curlurl2
    }
  }, [_vm._v("快速定制")]), _vm._v(" "), _c('a', {
    attrs: {
      "tag": "a",
      "target": "_blank",
      "rel": "nofollow",
      "href": "https://www.izhaowo.com/workerRecruit"
    }
  }, [_vm._v("招募婚礼人")])]), _vm._v(" "), _c('p', {
    staticClass: "copeRight",
    staticStyle: {
      "min-width": "600px"
    }
  }, [_c('span', {
    staticClass: "qianhui"
  }, [_vm._v("增值电信业务经营许可证：")]), _vm._v(" "), _c('span', {
    staticClass: "shenhui"
  }, [_vm._v("川B2-20140181")]), _vm._v(" "), _c('i', {
    staticClass: "qianhui"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "qianhui"
  }, [_vm._v("© " + _vm._s(_vm.nowYear) + " izhaowo.com ")]), _vm._v(" "), _c('a', {
    staticClass: "shenhui",
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("蜀ICP备14014073号-1")])]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "fr wechat"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isWX),
      expression: "isWX"
    }],
    staticClass: "open-wx"
  }, [_c('img', {
    attrs: {
      "src": "https://img.izhaowo.com/pc-wap/image/login_weixin3.png"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "cup",
    staticStyle: {
      "margin-right": "12px"
    },
    attrs: {
      "src": require("../../assets/images/login_weixin-v2.png")
    },
    on: {
      "mouseover": function($event) {
        return _vm.setIsWX(true)
      },
      "mouseleave": function($event) {
        return _vm.setIsWX(false)
      }
    }
  }), _vm._v(" "), _vm._m(9)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', [_c('img', {
    attrs: {
      "src": "https://img.izhaowo.com/pc-wap/image/group-qrcode.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "down-app"
  }, [_c('dt', [_vm._v("下载APP")]), _vm._v(" "), _c('dd', [_c('img', {
    attrs: {
      "src": "https://img.izhaowo.com/pc-wap/image/new-down-app.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', [_c('dt', [_vm._v("小程序")]), _vm._v(" "), _c('dd', [_c('img', {
    attrs: {
      "src": "https://img.izhaowo.com/pc-wap/image/new-ico-wechat.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "class-name"
  }, [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "/case"
    }
  }, [_vm._v("婚礼案例")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "class-name"
  }, [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "/worker"
    }
  }, [_vm._v("婚礼团队")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "class-name"
  }, [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "/hotel"
    }
  }, [_vm._v("婚礼酒店")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "class-name"
  }, [_c('a', {
    staticClass: "title"
  }, [_vm._v("婚庆公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "copeRight",
    staticStyle: {
      "margin-top": "22px"
    }
  }, [_c('span', {
    staticClass: "qianhui"
  }, [_vm._v("成都爱找我科技有限公司")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tel fr",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("客服热线（周一至周日9:00 - 18:30）")]), _vm._v(" "), _c('p', {
    staticClass: "phone"
  }, [_vm._v("4000-119-139")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://weibo.com/izhaowo?is_hot=1",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "cup",
    attrs: {
      "src": require("../../assets/images/login_wb-v2.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-583e1956","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/foot-bar-new.vue
// module id = 237
// module chunks = 1 5